import {Injectable} from '@angular/core';
import {Socket} from 'ngx-socket-io';
import { V2NODE_URL } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AlertSocketService extends Socket {
  constructor() {
    const url = V2NODE_URL + '/alert';
    super({url: url, options: {}});
  }
}
